/**
 * Question ids of the entity (ADB affiliate) questionnaire that feed the
 * TaxBit SDK prefill, keyed by what each one means for the SDK.
 */
export const ENTITY_TAX_PREFILL_QUESTION_IDS = {
  name: 'entityName',
  incorporationCountry: 'incorporationCountry',
  hasUsTaxpayer: 'hasUsTaxpayer',
  tin: 'fein',
  country: 'country',
  streetAddress: 'streetAddress',
  streetAddressSecond: 'streetAddressSecond',
  city: 'city',
  stateUS: 'stateUS',
  state: 'state',
  zipCode: 'zipCode',
} as const;

export type TaxPrefillQuestionIDs = Record<
  keyof typeof ENTITY_TAX_PREFILL_QUESTION_IDS,
  string
>;

/**
 * Question ids of the HNWI (individual) questionnaire that feed the TaxBit
 * SDK prefill. `incorporationCountry` holds the country of citizenship.
 */
export const HNWI_TAX_PREFILL_QUESTION_IDS = {
  name: 'entityNameHNWI',
  incorporationCountry: 'countryOfCitizenship',
  hasUsTaxpayer: 'hasUsTaxpayerHnwi',
  tin: 'feinHnwi',
  country: 'hnwiCountry',
  streetAddress: 'hnwiStreetAddress',
  streetAddressSecond: 'hnwiStreetAddressSecond',
  city: 'hnwiCity',
  stateUS: 'hnwiStateUS',
  state: 'hnwiState',
  zipCode: 'hnwiZipCode',
} as const satisfies TaxPrefillQuestionIDs;
